
import '../../App.css';
import { Link } from 'react-router-dom';
import logo from '../../images/logo-dark.png'
// import { MdLineWeight } from "react-icons/md";
const Header = ({ gotoFeature }) => {
    return (
        <header>
            <nav className="container flex items-center py-4 mt-4 sm:mt-12">
                <Link to="/"><div className='cursor-pointer flex align-center justify-center py-1'>
                    <img src={logo} alt="Logo" className="w-12 h-12" />
                    <h1 className='hidden lg:block text-lg ml-4 font-bold text-primary align-center mt-4'>Owaa</h1>
                </div></Link>
                <ul className='hidden sm:flex flex-1 justify-end items-center gap-12 text-primary uppercase text-xs'>
                    <li className='cursor-pointer'><Link to="/">Home</Link></li>
                    <li onClick={gotoFeature} className='cursor-pointer'>Features</li>
                </ul>
                {/* // when used, add "justify-center" class to the nav */}
                {/* <div className='flex sm:hidden flex-1 justify-end'>
                    <MdLineWeight style={{ fontSize: '20px' }} />
                </div> */}
            </nav>
        </header>
    );
}

export default Header;
